import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ClientProvider } from './contexts/ClientContext';
import { ToastProvider } from './contexts/ToastContext';
import { UiLocaleProvider } from './contexts/UiLocaleContext';
import ProtectedRoute from './auth/ProtectedRoute';
import Login from './auth/Login';
import MakeApp from './app/MakeApp';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <UiLocaleProvider>
          <div className="min-h-screen bg-[rgb(224_231_255/0.6)]">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <ClientProvider>
                      <MakeApp />
                    </ClientProvider>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
          </UiLocaleProvider>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
